<template>
  <div>
    <div class="call-check el-input-group el-input-group--append el-input-group--prepend">
      <div class="el-input-group__prepend">Was</div>
      <el-select
        v-close-on-zoom
        :value="state.selectedCallId"
        placeholder="Select callee"
        :disabled="readonly"
        class="call-select"
        @input="(callId) => selectCall(callId)"
      >
        <el-option
          v-for="call in emitter.caseConf.dialogue.calls"
          :key="call.id"
          :label="call.callee.en"
          :value="call.id"
        />
      </el-select>
      <dialogue-check
        check-type="UNSOLICITED_CALL"
        placeholder="Select Unsolicited"
        prefix="played"
        :get-dialogue-items="getSelectedCallItems"
        :get-dialogue-item-content="(item) => item.options.answer"
        :put-data="putDataWithCallId"
        v-bind="$props"
      />
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';

import DialogueCheck from './DialogueCheck.vue';

export default {
  name: 'unsolicited-callee-check',
  components: {
    DialogueCheck,
  },
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        selectedCallId: null,
      },
    };
  },
  computed: {
    selectedCall() {
      const calls = get(this.emitter.caseConf, 'dialogue.calls', []);
      if (!calls) {
        return;
      }
      return calls.find((call) => call.id === this.state.selectedCallId);
    },
  },
  created() {
    const data = this.getData(this.ikey);
    this.state.selectedCallId = get(data, 'callId');
  },
  mounted() {
    this.emitter.trigger('process', this.control);
  },
  methods: {
    selectCall(callId) {
      this.state.selectedCallId = callId;
      // First time selecting a callee
      // We don't want to emit null id and
      // cause validation errors
      if (!this.getData(this.ikey)) {
        return;
      }
      this.putDataWithCallId(this.ikey, {
        type: 'UNSOLICITED_CALL',
        id: null,
      });
    },
    putDataWithCallId(key, data) {
      this.putData(key, {
        ...data,
        callId: this.state.selectedCallId,
      });
      this.emitter.trigger('process', this.control);
    },
    getSelectedCallItems() {
      if (!this.selectedCall) {
        return [];
      }
      return this.selectedCall.unsolicited;
    },
  },
};
</script>

<style scoped>
.call-select, .dialogue-check {
  display: table-cell;
}
</style>